import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LazyLoad = ({ children, posAbsolute, border }) => {
  const containerClass = classNames('lazy-load lazy-load--loading', {
    'lazy-load--absolute': posAbsolute,
    'border-1 border-color-grey--light border-radius-l': border,
  });

  return (
    <div className={containerClass}>
      { children }
    </div>
  );
};

LazyLoad.propTypes = {
  children: PropTypes.object,
  posAbsolute: PropTypes.bool,
  border: PropTypes.bool,
};

export default LazyLoad;



// WEBPACK FOOTER //
// ./library/app/components/Global/Loaders/LazyLoad.js